import { format, parseISO } from 'date-fns';

export interface RainTemperatureTooltipPoint {
  seriesName?: string;
  marker?: string;
  value: [string, number | null] | (string | number | null)[];
}

// "Chuva (mm)" → { label: "Chuva", unit: "mm" }. A unidade sai do próprio nome
// da série: a legenda continua com ela e o tooltip não a repete.
const SERIES_WITH_UNIT = /^(.*\S)\s*\(([^)]+)\)$/;

function splitSeriesName(seriesName = ''): { label: string; unit?: string } {
  const match = SERIES_WITH_UNIT.exec(seriesName);
  return match ? { label: match[1], unit: match[2] } : { label: seriesName };
}

function formatPoint({ seriesName, marker = '', value }: RainTemperatureTooltipPoint): string {
  const { label, unit } = splitSeriesName(seriesName);
  const raw = value[1];
  if (raw === null || raw === undefined) return `${marker} ${label}: sem dado<br/>`;
  return `${marker} ${label}: ${raw}${unit ? ` ${unit}` : ''}<br/>`;
}

// `parseISO` lê 'YYYY-MM-DD' como meia-noite LOCAL; `new Date('YYYY-MM-DD')` lê
// como UTC e, a oeste de Greenwich, mostrava o dia anterior ao do eixo (#2009).
function formatDay(day: string | number | null): string {
  if (typeof day === 'string') return format(parseISO(day), 'dd/MM/yyyy');
  return day === null ? '' : format(new Date(day), 'dd/MM/yyyy');
}

// Rótulo da mira ('cross') do gráfico: o dia no eixo do tempo; no eixo Y, o valor com uma
// casa e a unidade do eixo (0 = chuva, mm; 1 = temperatura, °C). Antes saía o float cru
// ("11.666666666666666"), sem unidade.
export function formatRainTemperatureAxisPointer({ axisDimension, axisIndex, value }: {
  axisDimension?: string;
  axisIndex?: number;
  value: number | string;
}): string {
  if (axisDimension === 'x') return format(new Date(Number(value)), 'dd/MM/yyyy');
  return `${Number(value).toFixed(1)} ${axisIndex === 1 ? '°C' : 'mm'}`;
}

export default function formatRainTemperatureTooltip(
  points: RainTemperatureTooltipPoint[],
): string {
  if (points.length === 0) return '';
  return `${formatDay(points[0].value[0])}<br/>${points.map(formatPoint).join('')}`;
}
